import { render, staticRenderFns } from "./cangchuSyPup.vue?vue&type=template&id=297a56fe&scoped=true&"
import script from "./cangchuSyPup.vue?vue&type=script&lang=js&"
export * from "./cangchuSyPup.vue?vue&type=script&lang=js&"
import style0 from "./cangchuSyPup.vue?vue&type=style&index=0&id=297a56fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297a56fe",
  null
  
)

export default component.exports